import { INSTAGRAM_HANDLE, STORE_TAGLINE } from '@neyara/shared';
import { Link } from 'react-router';
import { useConfig } from '../lib/queries';
import { useWhatsApp } from '../lib/whatsapp';
import { InstagramIcon, MailIcon, WhatsAppIcon } from './icons';
import { LotusDivider } from './lotus';

const linkClass = 'inline-flex min-h-10 items-center gap-3 text-champagne/85 transition-colors hover:text-gold';

export function SiteFooter() {
  const { data: config } = useConfig();
  const whatsapp = useWhatsApp();

  return (
    <footer className="on-maroon bg-maroon-deep text-champagne">
      <div className="mx-auto max-w-7xl px-4 pt-16 pb-10 sm:px-8">
        <div className="flex flex-col items-center text-center">
          <p className="font-display text-xl tracking-[0.32em] uppercase sm:text-2xl">House of Neyara</p>
          <LotusDivider className="mt-4" />
          <p className="mt-4 font-script text-2xl text-champagne/90 italic">{STORE_TAGLINE}</p>
        </div>

        <div className="mt-14 grid gap-10 border-t border-gold/25 pt-10 sm:grid-cols-2 lg:grid-cols-3">
          <div>
            <h2 className="font-display text-sm tracking-[0.22em] text-gold uppercase">Shop</h2>
            <ul className="mt-3 space-y-0.5">
              <li>
                <Link to="/sarees" className={linkClass}>
                  All sarees
                </Link>
              </li>
              <li>
                <Link to="/sarees?featured=true" className={linkClass}>
                  Featured
                </Link>
              </li>
              <li>
                <Link to="/sarees?sort=newest" className={linkClass}>
                  New arrivals
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-display text-sm tracking-[0.22em] text-gold uppercase">Talk to us</h2>
            <ul className="mt-3 space-y-0.5">
              {whatsapp && (
                <li>
                  <a href={whatsapp.chat()} target="_blank" rel="noopener noreferrer" className={linkClass}>
                    <WhatsAppIcon size={20} /> Chat on WhatsApp
                  </a>
                </li>
              )}
              <li>
                <a
                  href={`https://instagram.com/${INSTAGRAM_HANDLE}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClass}
                >
                  <InstagramIcon size={20} /> @{INSTAGRAM_HANDLE}
                </a>
              </li>
              {config?.contactEmail && (
                <li>
                  <a href={`mailto:${config.contactEmail}`} className={linkClass}>
                    <MailIcon size={20} /> {config.contactEmail}
                  </a>
                </li>
              )}
            </ul>
          </div>

          <div className="sm:col-span-2 lg:col-span-1">
            <h2 className="font-display text-sm tracking-[0.22em] text-gold uppercase">How ordering works</h2>
            <p className="mt-3 max-w-sm text-champagne/80">
              Choose a saree, or fill your bag, and order on WhatsApp. We confirm availability, delivery and payment with
              you in the chat.
            </p>
          </div>
        </div>

        <p className="mt-14 text-center text-sm text-champagne/60">
          © {new Date().getFullYear()} House of Neyara
        </p>
      </div>
    </footer>
  );
}
